import { useState } from 'react';

const testimonials = [
  {
    rating: "4.9",
    text: "This CSSBuy Spreadsheet completely changed how I shop. Instead of spending hours digging through random Yupoo albums and Reddit threads, I can find exactly what I want in minutes. The category organization is intuitive, and every link I've tried actually works — no dead ends. The weekly updates keep things fresh, and I've discovered so many great sellers I would have never found on my own. Honestly, this is the resource I wish existed when I first started using CSSBuy three years ago.",
    name: "Marcus Chen",
    role: "CSSBuy User since 2023",
  },
  {
    rating: "4.8",
    text: "I was skeptical at first because there are so many spreadsheets floating around, but this one is genuinely on another level. The fact that every single link goes through kaspreadsheet.com with a clean consistent interface makes browsing so much smoother. I've found at least 20 items I ended up buying — shoes, hoodies, accessories — all from verified sellers with solid QC references. The spreadsheet saves me probably 5-6 hours of browsing every month. Cannot recommend it enough to anyone in the rep community.",
    name: "Jordan Park",
    role: "Community Contributor",
  },
  {
    rating: "4.9",
    text: "As someone who runs a small reselling operation, having access to an organized comprehensive spreadsheet is absolutely essential. This CSSBuy Spreadsheet has become my go-to resource for sourcing inventory. The 14 category breakdown means I can quickly jump between shoes, accessories, and clothing without losing my workflow. The seller verification aspect gives me confidence that I am not wasting time on unreliable vendors. I check the updates every Monday morning — it's become part of my weekly routine.",
    name: "Alex Rivera",
    role: "Verified Reseller",
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <p className="text-center font-heading text-lg text-foreground-500 italic mb-10">
          (Trusted by Thousands)
        </p>

        <div className="relative">
          <div className="flex items-start gap-4 mb-4">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-foreground-900 text-background-50 text-sm font-semibold rounded-full">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              {t.rating}
            </span>
          </div>

          <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed font-serif italic">
            &ldquo;{t.text}&rdquo;
          </blockquote>

          <div className="mt-8 flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-secondary-300 flex items-center justify-center text-foreground-700 font-bold text-lg">
              {t.name.charAt(0)}
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
              <p className="text-xs text-foreground-500">{t.role}</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between mt-10">
          <div className="flex gap-1.5">
            {testimonials.map((_, idx) => (
              <span
                key={idx}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  idx === current ? 'bg-foreground-900 w-6' : 'bg-foreground-300'
                }`}
              ></span>
            ))}
          </div>
          <div className="flex gap-2">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-300 text-foreground-600 hover:bg-background-50 transition-colors cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}